import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { type CSSProperties } from 'react';

export type BoxProps = {
  m?: CSSProperties['margin'];
  mt?: CSSProperties['marginTop'];
  mb?: CSSProperties['marginBottom'];
  ml?: CSSProperties['marginLeft'];
  mr?: CSSProperties['marginRight'];
  mx?: CSSProperties['marginTop'];
  my?: CSSProperties['marginLeft'];
  p?: CSSProperties['padding'];
  pt?: CSSProperties['paddingTop'];
  pb?: CSSProperties['paddingBottom'];
  pl?: CSSProperties['paddingLeft'];
  pr?: CSSProperties['paddingRight'];
  px?: CSSProperties['paddingLeft'];
  py?: CSSProperties['paddingTop'];
  w?: CSSProperties['width'];
  miw?: CSSProperties['minWidth'];
  maw?: CSSProperties['maxWidth'];
  h?: CSSProperties['height'];
  mih?: CSSProperties['minHeight'];
  mah?: CSSProperties['maxHeight'];
  flex?: CSSProperties['flex'];
};

export const getBoxStyles = <PROPS extends BoxProps>(p: PROPS) => css`
  margin-top: ${p.mt || p.my || p.m || 0};
  margin-bottom: ${p.mb || p.my || p.m || 0};
  margin-left: ${p.ml || p.mx || 0};
  margin-right: ${p.mr || p.mx || p.m || 0};

  padding-top: ${p.pt || p.py || p.p || 0};
  padding-left: ${p.pl || p.py || p.p || 0};
  padding-right: ${p.pr || p.px || p.p || 0};
  padding-bottom: ${p.pb || p.px || p.p || 0};

  width: ${p.w || 'auto'};
  min-width: ${p.miw || 'auto'};
  max-width: ${p.maw || 'none'};

  height: ${p.h || 'auto'};
  min-height: ${p.mih || 'auto'};
  max-height: ${p.mah || 'none'};

  flex: ${p.flex || '0 1 auto'};
`;

/**
 * Box is a flexible container component
 * that provides convenient props for managing
 * spacing, dimensions, and flex properties.
 *
 * Available props:
 * - `m`, `mt`, `mb`, `ml`, `mr`, `mx`, `my` — margin
 * - `p`, `pt`, `pb`, `pl`, `pr`, `px`, `py` — padding
 * - `w`, `miw`, `maw` — width
 * - `h`, `mih`, `mah` — height
 * - `flex` — flex property value
 */
export const Box = styled('div')<BoxProps>`
  ${getBoxStyles};
`;
